import { render, staticRenderFns } from "./feedback-link.vue?vue&type=template&id=1a9dee7a&scoped=true"
import script from "./feedback-link.vue?vue&type=script&lang=js"
export * from "./feedback-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9dee7a",
  null
  
)

export default component.exports